<script setup>
import MatchMakingModal from "@/views/needs/MatchMakingModal.vue";
import {ref, computed} from "vue";
import NeedsAIChat from "@/views/needs/NeedsAIChat.vue";
import NeedsList from "@/views/needs/NeedsList.vue";

const matchMakingModal = ref(null);
const chat = ref(null);

function openMatchMakingModal() {
    matchMakingModal.value.open();
}

function startChat() {
    chat.value.open();
}


const VISIBLE_SLIDES = 3.6
const GAP_PX = 0


const slides = ref(Array(8).fill(null))


const currentIndex = ref(0)
const maxIndex = computed(() => slides.value.length - Math.floor(VISIBLE_SLIDES))

const slideWidthPercent = computed(() => 100 / VISIBLE_SLIDES)

const slideStyle = computed(() => ({
  flex: `0 0 calc(${slideWidthPercent.value}% - ${GAP_PX}px)`,
  maxWidth: `calc(${slideWidthPercent.value}% - ${GAP_PX}px)`,
}))

const trackStyle = computed(() => {
  return {
    transform: `translateX(calc(-${currentIndex.value * (100 / VISIBLE_SLIDES)}% - ${currentIndex.value * GAP_PX}px))`,
    transition: 'transform 0.4s ease',
  }
})

function prev() { if (currentIndex.value > 0) currentIndex.value-- }
function next() { if (currentIndex.value < maxIndex.value) currentIndex.value++ }
function goTo(i) { currentIndex.value = i }

const touchStartX = ref(0)
function onTouchStart(e) { touchStartX.value = e.touches[0].clientX }
function onTouchMove(e) { e.preventDefault() }
function onTouchEnd(e) {
  const delta = touchStartX.value - e.changedTouches[0].clientX
  if (delta > 50) next()
  else if (delta < -50) prev()
}
</script>

<template>
    <div class="needs-page">
        <MatchMakingModal ref="matchMakingModal"/>

        <h3 class="heading3 heading3--updates">Updates</h3>

        <!--  -->

        <div class="carousel-wrapper">
            <div class="carousel-track-container" ref="trackContainer">
                <div
                    class="carousel-track"
                    :style="trackStyle"
                    @touchstart="onTouchStart"
                    @touchmove="onTouchMove"
                    @touchend="onTouchEnd"
                >
                    
                    <div
                        v-for="(slide, index) in slides"
                        :key="index"
                        class="carousel-slide"
                        :style="slideStyle"
                    >
                        <div v-if="index === 0" class="carousel-slide__item">
                            <div class="carousel-slide__item__inner">
                                <div class="carousel-slide__content">
                                    <h5 class="heading5 heading5--secondary">Recycled plastic packaging</h5>

                                    <p>10 new AI matches</p>

                                    <ul class="list-matches">
                                        <li><a href="#"><img src="https://sp-images-dev.s3.amazonaws.com/173765293067927ac244c44.jpeg" alt="" /></a></li>
                                        <li><a href="#"><img src="https://sp-images-dev.s3.amazonaws.com/16496616736253d6e9c93ad.png" alt="" /></a></li>
                                        <li><a href="#"><img src="https://app2.dev.switchpitch.com/img/global.e72ae145.png" alt="" /></a></li>
                                        <li><a href="#"><img src="https://app2.dev.switchpitch.com/img/global.e72ae145.png" alt="" /></a></li>
                                        <li><a href="#"><img src="https://app2.dev.switchpitch.com/img/global.e72ae145.png" alt="" /></a></li>
                                        <li><a href="#"><img src="https://app2.dev.switchpitch.com/img/global.e72ae145.png" alt="" /></a></li>
                                    </ul>
                                </div>
                                <footer class="carousel-slide__footer">
                                    <a href="#" class="link-arrow">Review</a>
                                </footer>
                            </div>
                        </div>

                        <div v-else-if="index === 1" class="carousel-slide__item">
                            <div class="carousel-slide__item__inner">
                                <div class="carousel-slide__content">
                                    <h5 class="heading5 heading5--secondary">Recycled plastic packaging</h5>

                                    <div class="carousel-slide__notification">
                                        
                                    </div>

                                    <p>10 new AI matches</p>
                                </div>
                                <footer class="carousel-slide__footer">
                                    <a href="#" class="link-arrow">Review</a>
                                </footer>
                            </div>
                        </div>

                        <div v-else-if="index === 2" class="carousel-slide__item">
                            <div class="carousel-slide__item__inner">
                                <div class="carousel-slide__content">
                                    <h5 class="heading5 heading5--secondary">Recycled plastic packaging</h5>

                                    <p>10 new AI matches</p>
                                </div>
                                <footer class="carousel-slide__footer">
                                    <a href="#" class="link-arrow">Review</a>
                                </footer>
                            </div>
                        </div>

                        <div v-else-if="index === 3" class="carousel-slide__item">
                            <div class="carousel-slide__item__inner">
                                <div class="carousel-slide__content">
                                    <h5 class="heading5 heading5--secondary">Recycled plastic packaging</h5>

                                    <p>10 new AI matches</p>
                                </div>
                                <footer class="carousel-slide__footer">
                                    <a href="#" class="link-arrow">Review</a>
                                </footer>
                            </div>
                        </div>

                        <div v-else-if="index === 4" class="carousel-slide__item">
                            <div class="carousel-slide__item__inner">
                                <div class="carousel-slide__content">
                                    <h5 class="heading5 heading5--secondary">Recycled plastic packaging</h5>

                                    <p>10 new AI matches</p>
                                </div>
                                <footer class="carousel-slide__footer">
                                    <a href="#" class="link-arrow">Review</a>
                                </footer>
                            </div>
                        </div>

                        <div v-else-if="index === 5" class="carousel-slide__item">
                            <div class="carousel-slide__item__inner">
                                <div class="carousel-slide__content">
                                    <h5 class="heading5 heading5--secondary">Recycled plastic packaging</h5>

                                    <p>10 new AI matches</p>
                                </div>
                                <footer class="carousel-slide__footer">
                                    <a href="#" class="link-arrow">Review</a>
                                </footer>
                            </div>
                        </div>

                        <div v-else-if="index === 6" class="carousel-slide__item">
                            <div class="carousel-slide__item__inner">
                                <div class="carousel-slide__content">
                                    <h5 class="heading5 heading5--secondary">Recycled plastic packaging</h5>

                                    <p>10 new AI matches</p>
                                </div>
                                <footer class="carousel-slide__footer">
                                    <a href="#" class="link-arrow">Review</a>
                                </footer>
                            </div>
                        </div>

                        <div v-else-if="index === 7" class="carousel-slide__item">
                            <div class="carousel-slide__item__inner">
                                <div class="carousel-slide__content">
                                    <h5 class="heading5 heading5--secondary">Recycled plastic packaging</h5>

                                    <p>10 new AI matches</p>
                                </div>
                                <footer class="carousel-slide__footer">
                                    <a href="#" class="link-arrow">Review</a>
                                </footer>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <button class="carousel-btn carousel-btn--prev" @click="prev" :disabled="currentIndex === 0"></button>
            <button class="carousel-btn carousel-btn--next" @click="next" :disabled="currentIndex >= maxIndex"></button>

            <div class="carousel-dots">
                <span
                v-for="i in maxIndex + 1"
                :key="i"
                class="dot"
                :class="{ active: currentIndex === i - 1 }"
                @click="goTo(i - 1)"></span>
            </div>
        </div>
        <!--  -->

        <h3 class="heading3 heading3--needs">My Needs</h3>

        <div class="add-need-wrapper text-center mb-5">
            <a @click="startChat" class="link-add-need">Add New Need</a>
        </div>

        <NeedsList/>

        <NeedsAIChat ref="chat"/>

        <a class="link" @click="openMatchMakingModal">Match Making Modal</a>
    </div>
</template>

<style scoped>

</style>
